export default "__VITE_ASSET__CRzbRNKV__"